import React, { useState, useEffect } from "react";

const Resources = ({ accountPermission }) => {
  const [resourcesPageContent, setResourcesPageContent] = useState(null);
  useEffect(() => {
    setResourcesPageContent(
      document.getElementById("resourcesPageContent") &&
        document.getElementById("resourcesPageContent").innerHTML
    );
  }, []);

  useEffect(() => {
    if (document.querySelector("a.btn[href$='/vacancies']")) {
      if (accountPermission.seeBookings) {
        document.querySelector("a.btn[href$='/vacancies']").style.display = "";
      } else {
        document.querySelector("a.btn[href$='/vacancies']").style.display =
          "none";
      }
    }
    if (document.querySelector("a.btn[href$='/timesheets']")) {
      if (accountPermission.seeTimesheets) {
        document.querySelector("a.btn[href$='/timesheets']").style.display = "";
      } else {
        document.querySelector("a.btn[href$='/timesheets']").style.display =
          "none";
      }
    }
  });

  // trigger lozad lazy loader after any update
  useEffect(() => {
    // eslint-disable-next-line
    window.lozadObserver && window.lozadObserver.observe();
  });

  return <div dangerouslySetInnerHTML={{ __html: resourcesPageContent }} />;
};

export default Resources;
